import { QRCodeSVG } from 'qrcode.react'

interface Props {
  value: string
  size?: number
  imageUrl?: string
}

function QRCodeComponent(props: Props) {
  let imageSettings
  if (props.imageUrl) {
    // 30% of the QR code size
    const imageSize = props.size ? props.size * 0.3 : 0
    // places the image in the center of the QR code
    const imageX = props.size ? (props.size / 2) - (imageSize / 2) : 0
    const imageY = props.size ? (props.size / 2) - (imageSize / 2) : 0

    imageSettings = {
      src: props.imageUrl,
      x: imageX,
      y: imageY,
      height: imageSize,
      width: imageSize,
      excavate: false,
    }
  }
  return (
    <QRCodeSVG
      size={props.size}
      value={props.value}
      imageSettings={imageSettings}
    />
  )
}

export default QRCodeComponent
